import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from '../Components/Home/Home';
import About from '../Components/About/About';
import Testimonial from '../Components/Testimonial/Testimonial';
import Faq from '../Components/FAQ/Faq';
import Enginnering from '../Components/Enginnering/Enginnering';
import Medical from '../Components/medical/Medical';
import CbseEight from '../Components/cbse8th/CbseEight';
import IcseEight from '../Components/icse8th/IcseEight';
import CbseNine from '../Components/cbse9th/CbseNine';
import Centers from '../Components/centers/Centers';
import CbseTen from '../Components/cbse10th/CbseTen';
import NineIcse from '../Components/nineIcse/NineIcse';
import TenIcse from '../Components/tenIcse/TenIcse';
import ComingSoon from '../Components/ComingSoon/ComingSoon';
import Contact from '../Components/Contactus/Contact';
import SscEight from '../Components/ssc8th/SscEight';
import SscNine from '../Components/ssc9th/SscNine';
import SscTen from '../Components/ssc10th/SscTen';
import Tybcom from '../Components/bcom/Tybcom';
import Performannce from '../Components/performance booster/Performannce';
import Preschool from '../Components/preschool/Preschool';
import Igcseeight from '../Components/igcse8th/Igcseeight';
import Igcsenine from '../Components/igcse9th/Igcsenine';
import IgcseTen from '../Components/igcse10th/IgcseTen';
import Career from '../Components/Career/Career';
import MainFaq from '../Components/mainFaq/MainFaq';
import NotFound from '../Components/NotFound/NotFound';
import PrivacyPolicy from '../Components/PrivacyPlicy/PrivacyPolicy';
import TermsAndConditons from '../TermsAndConditions/TermsAndConditons';
import Refund from '../Refund/Refund';
import Sscmain from '../Components/SscMain/Sscmain';
import Cbsemain from '../Components/Cbsemain/Cbsemain';
import Icsemain from '../Components/icsemain/Icsemain';
import Igcsemain from '../Components/igcseMain/Igcsemain';
import Blogs from '../Components/blogs/Blogs';
import Mainblog from '../Components/mainblog/Mainblog';
import Papers from '../Components/papers/Papers';
import Olympiads from '../Components/olympiads/Olympiads';
import Notes from '../Components/notes/Notes';
import Enginnerone from '../Components/subenginnering/Enginnerone';
import Enginnertwo from '../Components/subenginnering/Enginnertwo';
import Enginnerthree from '../Components/subenginnering/Enginnerthree';
import Premedicalone from '../Components/subenginnering/Premedicalone';
import Premedicaltwo from '../Components/subenginnering/Premedicaltwo';
import Premedicalthree from '../Components/subenginnering/Premedicalthree';
import Landing from '../Components/landingpage/Landing';
import Thankyou from '../Components/thankyou/Thankyou';
import Anant from '../Components/anant_landing/Anant';
import ElevenAndTwelth from '../Components/ElevenAndTwelth/ElevenAndTwelth';
import ElevenAndTwelthCommerce from '../Components/ElevenAndTwelthCommerce/ElevenAndTwelthCommerce';
import IitJeeCoaching from '../Components/IitJeeCoaching/IitJeeCoaching';
import NeetCoaching from '../Components/NeetCoaching/NeetCoaching';
import Nsat from '../Components/Nsat/Nsat';
import TimeTable from '../Components/Time_Table/TimeTable';





const Pageroute = () => {
  // let location = document.URL.split("/blog")[1]
  // console.log(location, 'location is')
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/*
            Unknown URLs render a real 404 page instead of redirecting to the
            homepage. The old `<Navigate to='/' />` produced a soft 404: any
            mistyped or stale URL returned HTTP 200 with homepage content, which
            Google treats as an indexable duplicate of the homepage.
            The 404 status itself is set by ErrorDocument in public/.htaccess.
          */}
          <Route path='*' element={<NotFound />} />

          <Route path='/'>
            <Route index element={<Home />} />
          </Route>
          <Route path='/about'>
            <Route index element={<About />} />
          </Route>

          <Route path='/testimonial'>
            <Route index element={<Testimonial />} />
          </Route>
          {/* To commmetn  */}
          {/* <Route path='/elevenandTwelth'>
            <Route index element={<Faq />} />
          </Route> */}
          {/* end comment  */}
          <Route path='/11th-12th-science-coaching-classes-in-thane'>
            <Route index element={<ElevenAndTwelth />} />
          </Route>
          <Route path='/11th-12th-commerce-coaching-classes-in-thane'>
            <Route index element={<ElevenAndTwelthCommerce />} />
          </Route>
          <Route path='/iit-jee-classes-in-thane'>
            <Route index element={<IitJeeCoaching />} />
          </Route>
          <Route path='/neet-coaching-classes-in-thane'>
            <Route index element={<NeetCoaching />} />
          </Route>
          <Route path='/cbse-classes'>
            <Route index element={<CbseEight />} />
          </Route>

          <Route path='/icse-classes'>
            <Route index element={<IcseEight />} />
          </Route>

          <Route path='/ca'>
            <Route index element={<Medical />} />
          </Route>

          <Route path='/engineering'>
            <Route index element={<Enginnering />} />
          </Route>
          <Route path='/centers'>
            <Route index element={<Centers />} />
          </Route>
          <Route path='/comingSoon'>
            <Route index element={<ComingSoon />} />
          </Route>
          <Route path='/contact'>
            <Route index element={<Contact />} />
          </Route>
          <Route path='/timetable'>
            <Route index element={<TimeTable />} />
          </Route>
          <Route path='/tybcom'>
            <Route index element={<Tybcom />} />
          </Route>
          <Route path='/class-10-score-booster-course'>
            <Route index element={<Performannce />} />
          </Route>
          <Route path='/preschool'>
            <Route index element={<Preschool />} />
          </Route>

          
          <Route path='/igcse-classes'>
            <Route index element={<Igcseeight />} />
          </Route>

          <Route path='/classes-for-mh-ssc-board'>
            <Route index element={<SscEight />} />
          </Route>

          <Route path='/career'>
            <Route index element={<Career />} />
          </Route>


          <Route path='/mainfaq'>
            <Route index element={<MainFaq />} />
          </Route>
          {/*
            Canonical policy URLs. The legacy paths below them are kept alive
            purely to preserve inbound links and are permanently redirected --
            by Apache for direct hits (see public/.htaccess) and by <Navigate
            replace> for in-app navigation. Removing a legacy path without its
            redirect would break every existing link to it.
          */}
          <Route path='/privacy-policy'>
            <Route index element={<PrivacyPolicy />} />
          </Route>
          <Route path='/terms-and-conditions'>
            <Route index element={<TermsAndConditons />} />
          </Route>
          <Route path='/refund-policy'>
            <Route index element={<Refund />} />
          </Route>

          <Route path='/privaypolicy' element={<Navigate to='/privacy-policy' replace />} />
          <Route path='/termsConditions' element={<Navigate to='/terms-and-conditions' replace />} />
          <Route path='/refund' element={<Navigate to='/refund-policy' replace />} />
          <Route path='/blog'>
            <Route index element={<Blogs />} />
          </Route>
          <Route path='/blog/:id'>
            <Route index element={<Mainblog />} />
          </Route>

          <Route path='/paper'>
            <Route index element={<Papers />} />
          </Route>


          <Route path='/olympiads'>
            <Route index element={<Olympiads />} />
          </Route>
          <Route path='/notes/matter-in-our-surroundings-class-9-science'>
            <Route index element={<Notes />} />
          </Route>
          <Route path='/ace-40-batch-for-iit-jee-integrated'>
            <Route index element={<Enginnerone />} />
          </Route>
          <Route path='/g-10-plus-batch-for-iit-jee-integrated'>
            <Route index element={<Enginnertwo />} />
          </Route>
          <Route path='/ace-40-batch-for-mht-cet-engineer'>
            <Route index element={<Enginnerthree />} />
          </Route>
          <Route path='/ace-40-batch-for-neet-ug-integrated'>
            <Route index element={<Premedicalone />} />
          </Route>
          <Route path='/g-10-plus-batch-for-neet-ug-integrated'>
            <Route index element={<Premedicaltwo />} />
          </Route>
          <Route path='/ace-40-batch-for-mht-cet-medical'>
            <Route index element={<Premedicalthree />} />
          </Route>
          
          <Route path='/8th-9th-10th-cbse-icse-ssc-coaching-classes'>
            <Route index element={<Landing />} />
          </Route>
          <Route path='/thankyou'>
            <Route index element={<Thankyou />} />
          </Route>
          <Route path='/Anant'>
            <Route index element={<Anant />} />
          </Route>
          <Route path='/Nsat'>
            <Route index element={<Nsat />} />
          </Route>


        </Routes>

      </BrowserRouter>
    </>
  )
}

export default Pageroute